const StringUtils = {
    /**
     * 
     * @param {String} tpl
     * @param {Object} values
     * @returns {String} La cadena resultante.
     */
    tplApply(tpl, values) {
        let re, out;
        if (Array.isArray(tpl)) {
            tpl = tpl.join('');
        }
        out = tpl;
        for (const key in values) {
            re = new RegExp('{' + key + '}', 'g');
            let value = values[key];
            if (value === null || value === undefined) {
                value = '';
            }
            out = out.replace(re, value);
        }
        return out;
    },
    /**
     * Retorna un objeto con los los paramentros de una URL.
     * @param {String} url 
     */
    getUrlParams(url) {
        let re = /.*\?(.*)/,
            search = url.match(re),
            arrayParams,
            out = {};
        // No params
        if (!search) {
            return out;
        }
        arrayParams = search[1].split('&');
        if (arrayParams.length) {
            for (let i = 0; i < arrayParams.length; i++) {
                const param = arrayParams[i].split('=');
                out[param[0]] = param[1];
            }
        }
        return out;
    },
    /**
     * 
     * @param {String} urlTpl URL template
     * Ejm: 'http:://example.com?myParam={myParam}'
     * @param {Object} values
     * Objeto con los valores a ser remplazados.
     */
    applyUrlParams(urlTpl, values) {
        return this.tplApply(urlTpl, values);
    },
    setUrlParams(baseUlr, params) {
        let url = baseUlr.replace(/\?.*/, ''),
            box = [];
        for (const key in params) {
            box.push(`${key}=${params[key]}`);
        }
        return url + '?' + box.join('&');
    }
}
export default StringUtils;